import { createContext, useCallback, useState } from 'react';
import Loader from '../../view/components/Loader';
import Overlay from '../../view/components/Overlay';

interface IGlobalLoaderContextValue {
  isLoading: boolean;
  handleLoaderStateChange: (value?: boolean) => void;
}

export const GlobalLoaderContext = createContext(
  {} as IGlobalLoaderContextValue,
);

export function GlobalLoaderProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleLoaderStateChange = useCallback((value?: boolean) => {
    setIsLoading((prevState) => value ?? !prevState);
  }, []);

  return (
    <GlobalLoaderContext.Provider
      value={{
        isLoading,
        handleLoaderStateChange,
      }}
    >
      {children}
      {isLoading && (
        <Overlay className="bg-surface-page/50 z-11 flex items-center justify-center backdrop-blur-xs">
          <Loader />
        </Overlay>
      )}
    </GlobalLoaderContext.Provider>
  );
}
